// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_0ca47","button":"b20ff","icon":"a96cf"};